import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../providers/AuthProvider';

export function PrivateRoute({ children }: any) {
  const { token } = useAuth();
  const location = useLocation();

  return token ? children : <Navigate to='/login' state={{ from: location }} />;
}
